import '../styles/main.scss'
import './helpers/dictionary'
import './helpers/loginCheck'
import './api/logOut'
import 'swiper/css'
import 'swiper/css/pagination'
import './smooth-scroll'

import 'media-chrome'
import './global/header-desktop'
import './vue-mounts'
import './myPage/myEvents'
import './myPage/myLivestreams'
import './global/header-mobile'
import './global/footer'
import './pages/oabPage'
import { showSpinner, hideSpinner } from './helpers/spinner'

const blockRouter = document.querySelector('[data-block-router]')
const bundles = document.querySelectorAll('[data-first-or-last-element]')

if (blockRouter && bundles) {
  bundles.forEach(bundle => {
    if (blockRouter.lastElementChild === bundle) {
      blockRouter.classList.add('!mb-0')
    }
    if (blockRouter.firstElementChild === bundle) {
      blockRouter.classList.add('!mt-0')
    }
  })
}

const isEventPage = document.querySelector<HTMLElement>('[data-event-page]')
if (isEventPage) {
  import('./eventPage')
}

const isAlgoliaEventsPage = document.querySelector<HTMLElement>('[data-algolia-events-page]')
if (isAlgoliaEventsPage) {
  import('./algolia/algolia-events-page')
}

const isAlgoliaPublicationsPage = document.querySelector<HTMLElement>('[data-algolia-publications-page]')
if (isAlgoliaPublicationsPage) {
  import('./algolia/algolia-publications-page')
}

const allSwipers = document.querySelectorAll<HTMLElement>('.swiper, [data-swipers]')

const loadSwipers = async () => {
  await import('./swiper')
  await import('./blocks/galleryBlock')
}

if (allSwipers.length > 0) {
  loadSwipers()
}

document.addEventListener('DOMContentLoaded', function () {
  const checkoutComplete = document.querySelector('[data-checkout-complete]')
  if (checkoutComplete) {
    const event = new CustomEvent('cartQuantityUpdated', {
      detail: { totalQuantity: 0 },
    })

    document.dispatchEvent(event)

    const containsMembership = document.querySelector('[data-checkout-complete]')?.getAttribute('data-contains-membership')
    const totalPrice = document.querySelector('[data-checkout-complete]')?.getAttribute('data-total')

    if (containsMembership === 'True') {
      window.plausible('boughtMembership')
      console.log('containsMembership', containsMembership)
    }
    if (totalPrice) {
      const price = parseFloat(totalPrice)
      console.log('Pris', price)
      window.plausible('sales', { revenue: { currency: 'DKK', amount: price } })
      console.log(window.plausible('sales', { revenue: { currency: 'DKK', amount: price } }))
    }
  }

  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has('showLogin')) {
    const loginModal = document.querySelector('[data-login]')
    if (loginModal) {
      loginModal.classList.remove('hidden')
    }
  }
})

const video = document.querySelector('[data-video]') as HTMLVideoElement
if (video) {
  import('./blocks/videoBlock').then(module => {
    module.init(video)
  })
}

const lightbox = document.querySelector('[data-lightbox="gallery"]')
if (lightbox) {
  import('./blocks/galleryBlock').then(module => {
    module.init(lightbox)
  })
}

const accordionTriggers = document.querySelectorAll('[data-accordion-trigger]')
if (accordionTriggers) {
  import('./blocks/accordion').then(module => {
    module.init(accordionTriggers)
  })
}

const seriesContainers = document.querySelectorAll('[data-series-container]')
if (seriesContainers) {
  import('./myPage/mySeries').then(module => {
    module.init()
  })
}

const orderHistory: HTMLElement = document.querySelector('[data-order-history]')
if (orderHistory) {
  showSpinner(orderHistory)
  import('./api/orderHistory').then(module => {
    module.fetchOrderHistory(orderHistory).finally(() => {
      hideSpinner(orderHistory)
    })
  })
}
